import { render } from "./BranchesList.vue?vue&type=template&id=486ecf17"
import script from "./BranchesList.vue?vue&type=script&lang=js"
export * from "./BranchesList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/branches/BranchesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "486ecf17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('486ecf17', __exports__)) {
    console.log('reload')
    api.reload('486ecf17', __exports__)
  }
  
  module.hot.accept("./BranchesList.vue?vue&type=template&id=486ecf17", () => {
    console.log('re-render')
    api.rerender('486ecf17', render)
  })

}


export default __exports__